import React from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';

import { IMInputText, IMSelect, IMTextArea } from '@insurancemenu/imenu-components-lib';
import {
  IMZipCodeField,
  IMZipCountyField,
  IMZipStateField,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/zip';
import { Add, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';

import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import { MegaWideButtonWrapper, SectionCategoryStyled, IMFormModalStyled, ButtonStyled } from './styles';
import { CREATE_GROUP_FORM_ID } from '../constants';

interface ConfirmNewGroupModalProps {
  show: boolean;
  onClose: () => void;
}

const ConfirmNewGroupModal: React.FC<ConfirmNewGroupModalProps> = observer(({ show, onClose }) => {
  const {
    confirmNewGroupModalDelegate: { groupForm, availableAgentsOfRecord, useTinStrategy },
  } = useGroupDashboardPageStore();

  const agentsOfRecords = availableAgentsOfRecord.map((dateObj) => toJS(dateObj)).slice();

  const [shortForm, setShortForm] = React.useState(true);

  const onModalClose = (): void => {
    groupForm.resetForm();
    onClose();
  };

  return (
    <IMFormModalStyled
      formId={CREATE_GROUP_FORM_ID}
      formController={groupForm}
      title="Group Info"
      subtitle="Find an existing or create a new group"
      formContent={
        <>
          <IMInputText label="Group Name" name="name" size="full" />
          {useTinStrategy ? (
            <IMInputText label="TIN" name="tin" size="full" maxLength={9} />
          ) : (
            <IMSelect label="Agents of Record" name="agentOfRecord" size="full" options={agentsOfRecords} />
          )}
          {shortForm ? (
            <MegaWideButtonWrapper>
              <ButtonStyled
                type="text"
                color="primary"
                size="small"
                uppercase
                onClick={(): void => setShortForm(false)}
                leftIconProp={<Add />}
              >
                Add Group Details (Optional)
              </ButtonStyled>
            </MegaWideButtonWrapper>
          ) : (
            <>
              <MegaWideButtonWrapper>
                <ButtonStyled
                  type="text"
                  color="primary"
                  size="small"
                  uppercase
                  onClick={(): void => setShortForm(true)}
                  leftIconProp={<ChevronUp />}
                >
                  Hide Group Details
                </ButtonStyled>
              </MegaWideButtonWrapper>
              <SectionCategoryStyled>Main Contact Information</SectionCategoryStyled>
              <IMInputText label="First Name" name="firstName" size="m" />
              <IMInputText label="Last Name" name="lastName" size="m" />
              <IMInputText label="Phone Number" name="primaryPhone" size="m" />
              <IMInputText label="Title " name="title" size="m" />
              <IMInputText label="Email Address" name="primaryEmail" size="full" />
              <SectionCategoryStyled>Physical Address</SectionCategoryStyled>
              <IMInputText label="City" name="city" size="full" />
              <IMInputText label="Street" name="street" size="m" />
              <IMInputText label="Street 2" name="street2" size="m" />
              <IMZipCodeField size="s" />
              <IMZipStateField size="s" />
              <IMZipCountyField size="s" />
              <SectionCategoryStyled>Notes</SectionCategoryStyled>
              <IMTextArea label="Notes" name="notes" size="full" />
            </>
          )}
        </>
      }
      show={show}
      onClose={onModalClose}
    />
  );
});

export default ConfirmNewGroupModal;
